




import Vue from 'vue';
import InformationDelete from '@/components/information/information-delete.component.vue';

export default Vue.extend({
  components: {
    'information-delete': InformationDelete,
  },
});
